import script from "./password.vue?vue&type=script&setup=true&lang=ts"
export * from "./password.vue?vue&type=script&setup=true&lang=ts"

import "./password.vue?vue&type=style&index=0&id=c752da60&lang=less"

const __exports__ = script;

export default __exports__